export default {
    ORDER_CREATE_SHIPMENT: "[SHIPPING] ORDER CREATE SHIPMENT",
    ORDER_CREATE_SHIPMENT_AFTER: "[SHIPPING] ORDER CREATE SHIPMENT AFTER",
    ORDER_CREATE_SHIPMENT_LOAD_PRODUCT_QTYS_BEGIN: "[SHIPPING] ORDER CREATE SHIPMENT LOAD PRODUCT QTYS BEGIN",
    ORDER_CREATE_SHIPMENT_LOAD_PRODUCT_QTYS_AFTER: "[SHIPPING] ORDER CREATE SHIPMENT LOAD PRODUCT QTYS AFTER",
    ORDER_SET_IS_CREATING_SHIPMENT: "[SHIPPING] ORDER SET IS CREATING SHIPMENT",
    CHECKOUT_SET_IS_CREATE_SHIPMENT: "[SHIPPING] CHECKOUT ORDER SET IS CREATE SHIPMENT",

    PRODUCT_TOGETHER_SHIP_TYPE: 0,
    PRODUCT_SEPARATELY_SHIP_TYPE: 1,

    REQUEST_ORDER_CREATE_SHIPMENT: "request_order_create_shipment",
    REQUEST_ORDER_CREATE_SHIPMENT_ENDPOINT: '/V1/webposshipping/order/createShipment'
}


// WEBPACK FOOTER //
// ./src/extension/take-shipment/view/constant/order/ShippingConstant.js